export default __webpack_public_path__ + "static/media/St.9c0bf0fb.png";